import React, { useState } from 'react';
import tw, { styled } from 'twin.macro';

import {
  Flex,
  Panel,
  PageWrapper,
  OneHalfLayout
} from '@sopranodesign/pulse-components';
import {
  useAuth,
  FEATURE_GATES,
  FeatureFilter,
  GlobalRoleFilter,
  GlobalFeatureGateFilter
} from '@sopranodesign/pulse-auth';
import { BackButton } from '@sopranodesign/pulse-channels';

import { BotSettingsProvider } from '../Providers';
import {
  FontCode,
  EmbedPreview,
  SaveSettings,
  AvatarSettings,
  DeploymentCode,
  ComposerSettings,
  EmbedColourSettings,
  EmbedFooterSettings,
  SettingPageSettings,
  EmbedGeneralSettings
} from '../Components';
import {
  getEmbedSettings,
  updateEmbedSettings,
  updateEmbedLogo
} from '../api';
import SettingsTabs from '../Components/Shared/SettingsTabs';

const StyledContainer = styled.div`
  ${tw`flex flex-auto flex-col-reverse xl:flex-row xl:justify-start`}
`;

const StyledPanel = styled(Panel)`
  border-top-left-radius: 0;
`;

const EmbedSettings = () => {
  const [settingSection, setSettingSection] = useState('main');

  const { client } = useAuth();

  const deployment = {
    script: `<iframe src="${process.env.REACT_APP_EMBED_PAGE_DEPLOYMENT_ROOT_URL}?c=${process.env.REACT_APP_INSTALL_NAME}&i=${client.identifier}" id="chat-widget-1925" style="border: none; width: 100%; height: 100%;"></iframe>`,
    info: 'Paste this snippet anywhere on your web page.'
  };

  return (
    <PageWrapper
      header="Embedded widget"
      prevAction={<BackButton to="/channels" />}
      subheader="Manage the appearance of your Embedded widget"
    >
      <BotSettingsProvider
        type="embed"
        getBotSettings={getEmbedSettings}
        updateBotLogo={updateEmbedLogo}
        updateBotSettings={updateEmbedSettings}
        deploymentDetails={deployment}
      >
        <Flex xSpace>
          <OneHalfLayout>
            <StyledPanel>
              <Flex col growShrink>
                <SettingsTabs
                  section={settingSection}
                  onChange={setSettingSection}
                  sections={[
                    { key: 'main', label: 'Main' },
                    { key: 'engagement', label: 'Engagement' },
                    { key: 'design', label: 'Design' },
                    { key: 'advanced', label: 'Advanced' }
                  ]}
                />

                <StyledContainer>
                  <Flex col gap growShrink>
                    {settingSection === 'main' && (
                      <>
                        <DeploymentCode hideTitle />
                        <EmbedGeneralSettings />
                      </>
                    )}

                    {settingSection === 'engagement' && (
                      <>
                        <ComposerSettings />
                      </>
                    )}

                    {settingSection === 'design' && (
                      <>
                        <EmbedColourSettings />

                        <GlobalFeatureGateFilter
                          for={FEATURE_GATES.WHITELABEL_FOOTER}
                        >
                          <FeatureFilter feature="whitelabel footer">
                            <GlobalRoleFilter for="owner">
                              <EmbedFooterSettings />
                            </GlobalRoleFilter>
                          </FeatureFilter>
                        </GlobalFeatureGateFilter>

                        <FontCode />

                        <AvatarSettings />
                      </>
                    )}

                    {settingSection === 'advanced' && (
                      <>
                        <SettingPageSettings />
                      </>
                    )}

                    <SaveSettings />
                  </Flex>
                </StyledContainer>
              </Flex>
            </StyledPanel>
          </OneHalfLayout>

          <OneHalfLayout>
            <EmbedPreview />
          </OneHalfLayout>
        </Flex>
      </BotSettingsProvider>
    </PageWrapper>
  );
};

export default EmbedSettings;